import { ACTION_STATUS } from "../actionbar-detail.constant";
import { ButtonBase } from "./button.base";

export class AddIndividualButtonModel extends ButtonBase {
    label: string = '+ Individual';
    action: string = ACTION_STATUS.addIndividual;
    matIconName: string = '';
    colorClass: string = 'color-info-500';
}